(function () {
  'use strict';

  var ADD_BUNDLE_TEXT = 'add bundle to cart';
  var HIDDEN_CLASS = 'mm-fastbundle-duplicate-hidden';
  var PRIMARY_CLASS = 'mm-fastbundle-primary-card';

  function normalize(text) {
    return String(text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isAddBundleButton(el) {
    if (!el) return false;
    var text = normalize(el.textContent || el.value || el.getAttribute('aria-label'));
    return text.indexOf(ADD_BUNDLE_TEXT) !== -1;
  }

  function countAddBundleButtons(root) {
    if (!root || !root.querySelectorAll) return 0;
    return Array.prototype.filter.call(
      root.querySelectorAll('button, a, input[type="button"], input[type="submit"], [role="button"]'),
      isAddBundleButton
    ).length;
  }

  function looksLikeBundleCard(el) {
    if (!el || !el.querySelectorAll) return false;
    var text = normalize(el.textContent);
    if (text.indexOf('total') === -1) return false;
    if (text.indexOf('bundle') === -1) return false;
    if (countAddBundleButtons(el) !== 1) return false;

    var rect = el.getBoundingClientRect ? el.getBoundingClientRect() : { width: 0, height: 0 };
    return rect.width > 220 && rect.height > 90;
  }

  function findBundleCard(button) {
    var node = button;
    var best = null;
    var safety = 0;

    while (node && node !== document.body && safety < 18) {
      if (looksLikeBundleCard(node)) {
        best = node;

        var parentButtonCount = node.parentElement ? countAddBundleButtons(node.parentElement) : 0;
        if (parentButtonCount > 1) break;
      }

      node = node.parentElement;
      safety += 1;
    }

    return best;
  }

  function uniqueNodes(nodes) {
    var list = [];
    nodes.forEach(function (node) {
      if (node && list.indexOf(node) === -1) list.push(node);
    });
    return list;
  }

  function tidyFastBundleProductCards() {
    var productInfo = document.querySelector('.template-product .m-main-product--info, .m-main-product--info');
    if (!productInfo) return;

    var buttons = Array.prototype.filter.call(
      productInfo.querySelectorAll('button, a, input[type="button"], input[type="submit"], [role="button"]'),
      isAddBundleButton
    );

    if (buttons.length <= 1) return;

    var cards = uniqueNodes(buttons.map(findBundleCard).filter(Boolean));
    if (cards.length <= 1) return;

    cards.forEach(function (card, index) {
      if (index === 0) {
        card.classList.remove(HIDDEN_CLASS);
        card.classList.add(PRIMARY_CLASS);
        card.setAttribute('data-mm-fastbundle-card', 'primary');
      } else {
        card.classList.add(HIDDEN_CLASS);
        card.setAttribute('data-mm-fastbundle-card', 'duplicate-hidden');
      }
    });
  }

  function runWithDelays() {
    tidyFastBundleProductCards();
    window.setTimeout(tidyFastBundleProductCards, 400);
    window.setTimeout(tidyFastBundleProductCards, 1000);
    window.setTimeout(tidyFastBundleProductCards, 1800);
    window.setTimeout(tidyFastBundleProductCards, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWithDelays);
  } else {
    runWithDelays();
  }

  window.addEventListener('load', runWithDelays);
  document.addEventListener('shopify:section:load', runWithDelays);

  var observer = new MutationObserver(function () {
    window.clearTimeout(window.__mmFastBundleFixTimer);
    window.__mmFastBundleFixTimer = window.setTimeout(tidyFastBundleProductCards, 120);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
